<div class="px-8">
  <h5 class="text-xl font-semibold text-center text-title mt-1">
    Set up New Password
  </h5>
  <p class="text-base text-center">
    Please set a new password you can remember
  </p>

  <form
    nz-form
    class="flex flex-col gap-y-4 mt-6"
    [formGroup]="authForm"
    (ngSubmit)="onSubmit()"
    [nzLayout]="'vertical'"
  >
    <nz-form-item>
      <nz-form-label>Password</nz-form-label>
      <nz-form-control>
        <nz-input-group [nzAddOnAfter]="addOnAfterTemplate" nzSize="large">
          <input
            nz-input
            nzSize="large"
            [type]="!showPassword() ? 'password' : 'text'"
            formControlName="password"
            placeholder="Enter your password"
          />

          <ng-template #addOnAfterTemplate>
            <button
              type="button"
              nz-button
              nzType="text"
              (click)="toggleShowPassword('main')"
            >
              <svg-icon
                *ngIf="showPassword()"
                src="assets/svgs/eye_closed.svg"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              ></svg-icon>

              <svg-icon
                *ngIf="!showPassword()"
                src="assets/svgs/eye_open.svg"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              ></svg-icon>
            </button>
          </ng-template>
        </nz-input-group>

        <ng-container *ngIf="authForm.controls['password'].errors">
          <ng-container *ngIf="authForm.controls['password'].errors['length']">
            <p [ngStyle]="{ color: '#ff4d4f' }" nz-form-explain>
              Password must be at least 8 characters long.
            </p>
          </ng-container>
          <ng-container *ngIf="authForm.controls['password'].errors['upper']">
            <p [ngStyle]="{ color: '#ff4d4f' }" nz-form-explain>
              Password must contain at least one uppercase.
            </p>
          </ng-container>
          <ng-container *ngIf="authForm.controls['password'].errors['lower']">
            <p [ngStyle]="{ color: '#ff4d4f' }" nz-form-explain>
              Password must contain at least one lowercase.
            </p>
          </ng-container>
          <ng-container *ngIf="authForm.controls['password'].errors['numeric']">
            <p [ngStyle]="{ color: '#ff4d4f' }" nz-form-explain>
              Password must contain at least one number.
            </p>
          </ng-container>
          <ng-container *ngIf="authForm.controls['password'].errors['symbol']">
            <p [ngStyle]="{ color: '#ff4d4f' }" nz-form-explain>
              Password must contain at least one special character.
            </p>
          </ng-container>
        </ng-container>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label>Confirm Password</nz-form-label>
      <nz-form-control nzErrorTip="Confirm Password is not equal to Password">
        <nz-input-group [nzAddOnAfter]="addOnAfterTemplate2" nzSize="large">
          <input
            nz-input
            nzSize="large"
            [type]="!showConfirmPassword() ? 'password' : 'text'"
            formControlName="confirmPassword"
            placeholder="Confirm your password"
          />

          <ng-template #addOnAfterTemplate2>
            <button
              type="button"
              nz-button
              nzType="text"
              (click)="toggleShowPassword('confirm')"
            >
              <svg-icon
                *ngIf="showConfirmPassword()"
                src="assets/svgs/eye_closed.svg"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              ></svg-icon>

              <svg-icon
                *ngIf="!showConfirmPassword()"
                src="assets/svgs/eye_open.svg"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              ></svg-icon>
            </button>
          </ng-template>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <button
      nz-button
      class="w-full flex justify-center"
      nzSize="large"
      nzType="primary"
      type="submit"
      [nzLoading]="mutation.isPending()"
    >
      Reset password
    </button>

    <span class="flex items-center w-full justify-center">
      <!-- <p>Already have an account? </p> -->
      <button type="button" nz-button nzType="link" (click)="backToLogin()">
        Back to Login
      </button>
    </span>
  </form>
</div>
